import React, { useState, useEffect } from 'react';
import axios from 'axios';

import CreateEditImmunizationModal from './widgets/CreateEditImmunizationModal';
import DownloadImmunizationRecordsModal from './widgets/DownloadImmunizationRecordsModal';
import ExemptionModal from './widgets/ExemptionModal';
import ImmunizationRecordSection from './ImmunizationRecordSection';
import StudentImmunizationsHeader from './StudentImmunizationsHeader';
import StudentInformationSection from './StudentInformationSection';
import UploadImmunizationModal from './widgets/UploadImmunizationModal';

const ShowImmunizations = (initialProps) => {
  const [props, setProps] = useState(initialProps);
  const {
    test_group: testGroup,
    test_group_user: testGroupUser,
    immunization_records: immunizationRecords,
    pending_statuses: pendingStatuses,
    exemption_categories: exemptionCategories,
    exemption_types: exemptionTypes,
    exemption_options: exemptionOptions,
    recommended_immunization_records: recommendedImmunizationRecords,
    reload_url: reloadUrl,
  } = props;

  const [selectedDose, setSelectedDose] = useState(null);
  const [shownModalType, setShownModalType] = useState(null); // types: "vaccine", "upload", "exemption", "download"

  const handleOpenCreateEditImmunizationModal = (dose) => {
    setSelectedDose(dose);
    setShownModalType("vaccine");
  };

  const reload = async () => {
    const response = await axios.get(reloadUrl);
    setProps(response.data);
  };

  useEffect(() => {
    const toastrMessage = localStorage.getItem('immunizationSuccessMessage');
    if (!!toastrMessage) {
      toastr.success(toastrMessage);
      localStorage.removeItem('immunizationSuccessMessage');
    }
  }, [testGroupUser.id]);

  return (
    <>
      <DownloadImmunizationRecordsModal
        onHide={() => setShownModalType(null)}
        show={shownModalType == "download"}
        testGroup={testGroup}
        testGroupUser={testGroupUser}
      />
      <ExemptionModal
        exemptionOptions={exemptionOptions}
        onHide={() => setShownModalType(null)}
        show={shownModalType == "exemption"}
        testGroup={testGroup}
      />
      <UploadImmunizationModal
        onHide={() => setShownModalType(null)}
        show={shownModalType == "upload"}
        testGroup={testGroup}
        testGroupUser={testGroupUser}
      />
      <CreateEditImmunizationModal
        onHide={() => {
          setShownModalType(null);
          setSelectedDose(null);
        }}
        reload={reload}
        selectedDose={selectedDose}
        show={shownModalType == "vaccine"}
        testGroup={testGroup}
        testGroupUser={testGroupUser}
      />
      <StudentImmunizationsHeader
        exemptionOptions={exemptionOptions}
        fullName={testGroupUser.user.full_name}
        immunizationStatus={testGroupUser.student_profile.immunization_status}
        setShownModalType={setShownModalType}
        testGroup={testGroup}
        testGroupImmunizationsExemptionUrl={`/test_groups/${testGroup.slug}/immunizations/exemptions/${testGroupUser.id}`}
      />
      <StudentInformationSection
        testGroupUser={testGroupUser}
      />
      <ImmunizationRecordSection
        exemptionCategories={exemptionCategories}
        exemptionOptions={exemptionOptions}
        exemptionTypes={exemptionTypes}
        immunizationRecords={immunizationRecords}
        immunizationStatus={testGroupUser.student_profile.immunization_status}
        openCreateDoseModal={() => handleOpenCreateEditImmunizationModal(null)}
        openEditDoseModal={(dose) => handleOpenCreateEditImmunizationModal(dose)}
        pendingStatuses={pendingStatuses}
        recommendedImmunizationRecords={recommendedImmunizationRecords}
        testGroup={testGroup}
        testGroupUser={testGroupUser}
      />
      <div className="my-4">
        <a href={`/test_groups/${testGroup.slug}/schools/student_profiles`}>Back</a>
      </div>
    </>
  )
};

export default ShowImmunizations;
